/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Invalid_InputInputs */

const en_admin_invite_codes_invalid_input = /** @type {(inputs: Admin_Invite_Codes_Invalid_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your input`)
};

/**
* | output |
* | --- |
* | "Please check your input" |
*
* @param {Admin_Invite_Codes_Invalid_InputInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_invalid_input = /** @type {((inputs?: Admin_Invite_Codes_Invalid_InputInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Invalid_InputInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_invalid_input(inputs)
});
export { admin_invite_codes_invalid_input as "admin.invite_codes.invalid_input" }